import { render, staticRenderFns } from "./CircleSpinner.vue?vue&type=template&id=2af5cf26&scoped=true&"
import script from "./CircleSpinner.vue?vue&type=script&lang=js&"
export * from "./CircleSpinner.vue?vue&type=script&lang=js&"
import style0 from "./CircleSpinner.vue?vue&type=style&index=0&id=2af5cf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5cf26",
  null
  
)

export default component.exports